import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
  },
  backButton: {
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  backIcon: {
    color: '#E94745',
    fontSize: 'clamp(12px, 1.60vw, 34px)',
    fontWeight: 700,
  },
  pageTitle: {
    fontSize: 'clamp(10px, 1.30vw, 25px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  enrollmentsContainer: {
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
